import {Injectable} from '@angular/core';
import {NeoStorageService} from "ng-neo/index";

export interface NeoHistory {
    title: string,
    href: string
}

@Injectable()
export class NeoHistoryService {
    constructor(private _storage: NeoStorageService) {}

    getAllHistory(): NeoHistory[] {
        return (this._storage.getFromSessionStorage("history") || []).slice(0,7);
    }

    addHistory(h: NeoHistory) {
        let history = this.getAllHistory();
        history.unshift(h);

        this._storage.setToSessionStorage("history", history);
    }

    clearHistory() {
        this._storage.removeFromSessionStorage("history");
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-history/neo-history.ts